import React from "react";
import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";

export const FooterBrand = () => (
  <div className="col-span-2 md:col-span-1">
    <Link
      to="/"
      className="text-2xl font-bold bg-gradient-to-r from-[#d4a5ad] to-[#b89a6d] bg-clip-text text-transparent"
    >
      Peptides For Med Spas
    </Link>
    <p className="text-[#7a6b62] mt-4 text-sm leading-relaxed">
      Educational storefront for peptides studied in med spa, aesthetic, longevity, and wellness research.
    </p>
    <div className="flex gap-4 mt-6">
      <a
        href="https://www.instagram.com/peptidesformedspas"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Follow us on Instagram"
        className="w-10 h-10 bg-white border border-[#f0d8d4] rounded-lg flex items-center justify-center text-[#7a6b62] hover:text-[#b89a6d] hover:border-[#d4a5ad] transition-all"
      >
        <Instagram className="w-5 h-5" />
      </a>
    </div>
  </div>
);

export default FooterBrand;
